import { Select } from "antd"
import React from "react"

const SelectSimType = ({ value, onChange, disabled, style={ height: "36px"} }) => {
  return (
    <Select
      placeholder="Loại hình SIM"
      title="Loại hình SIM"
      allowClear
      value={value}
      onChange={onChange}
      disabled = {disabled}
      style={ style}
    >
      <Select.Option value="2">Travel</Select.Option>
      <Select.Option value="1">IoT</Select.Option>
    </Select>
  )
}

export default SelectSimType
